class DynamicProviderKey {
    _value = null
    _providerKey = null
    _modifiers = null

    constructor(dynamicKey) {
        this._value = dynamicKey

        const token = dynamicKey.indexOf(':')
        if (token > 0) {
            this._providerKey = dynamicKey.substring(0, token)
            const modifierIndex = token + 1
            const modifiers = dynamicKey.substring(modifierIndex).split(':')
            this._modifiers = new Map()
            modifiers.forEach(m => {
                if (m.includes('=')) {
                    const modifier = m.split('=')
                    this._modifiers.set(modifier[0].toLowerCase(), modifier[1].toLowerCase())
                } else {
                    this._modifiers.set(m?.toLowerCase(), 'true')
                }
            })
        } else {
            this._providerKey = dynamicKey
            this._modifiers = new Map()
        }
    }

    get providerKey() {
        return this._providerKey
    }

    get providerRole() {
        return this._modifiers?.get("role")
    }

    toString() {
        return this._value
    }

    static extractProviderKey(providerKeyWithModifiers) {
        if (!providerKeyWithModifiers) {
            return providerKeyWithModifiers
        }
        const index = providerKeyWithModifiers.indexOf(':')
        if (index >= 0) {
            return providerKeyWithModifiers.substring(0, index)
        }
        return providerKeyWithModifiers
    }
}

export default DynamicProviderKey
